var appContainer = document.getElementById('entry-filter-app');
if (appContainer) {
  import('./filter-app.js').then(function (_ref) {
    var FilterApp = _ref["default"];
    new FilterApp(appContainer);
  });
}